import { Divider } from '@eventbrite/eds-divider';
import { Trending as TrendingSvg } from '@eventbrite/eds-iconography';
import loadable from '@loadable/component';
import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { DiscoverState, PaginationData } from '../../../../types';
import { SearchPivotAnchor } from './components/SearchPivotAnchor';
import './SearchPivotsContainer.scss';
import { SearchPivotSuggestionsProps } from './SearchPivotSuggestionsContainer';
import { getTrendingSearchData } from './selectors';

const SearchPivotSuggestions: FunctionComponent<SearchPivotSuggestionsProps> =
    loadable(() => import('./SearchPivotSuggestionsContainer'));

/**
 * Suggested actions for the user to take given low, empty, or
 * end of search results.
 *
 * Always displays the trending searches footer.
 *
 * @param {*} props
 */
type SearchResultsPivotsProps = {
    isLoading: boolean;
    pagination: PaginationData;
};

type SearchResultsPivotReduxProps = {
    trendingSearchData: {
        path?: string;
        text?: object;
    };
};

export const SearchResultsPivots = ({
    isLoading,
    pagination,
    trendingSearchData,
}: SearchResultsPivotsProps & SearchResultsPivotReduxProps) => {
    const isNextDisabled = pagination.page === pagination.pageCount;
    const hasEventResults = pagination.objectCount > 0;
    const shouldRenderSuggestions =
        !isLoading && (!hasEventResults || isNextDisabled);

    return (
        <div className="search-result-pivots">
            {shouldRenderSuggestions && (
                <SearchPivotSuggestions
                    isLoading={isLoading}
                    hasEventResults={hasEventResults}
                    isNextDisabled={isNextDisabled}
                />
            )}
            <div className="eds-l-pad-top-6 eds-l-pad-bot-10">
                <Divider color="ui-200" />
                {trendingSearchData && (
                    <SearchPivotAnchor
                        href={trendingSearchData.path}
                        text={trendingSearchData.text}
                        icon={<TrendingSvg />}
                    />
                )}
            </div>
        </div>
    );
};

const _mapStateToProps = (state: DiscoverState) => ({
    trendingSearchData: getTrendingSearchData(
        state.location,
        state.app.domain,
        state.shouldShowTrendingSearchPageLink,
    ),
});

export const SearchPivotsContainer =
    connect(_mapStateToProps)(SearchResultsPivots);
